import { OrderByArg } from "generated/schemaTypes";

export enum PaginatedTableFieldFilterTypes {
  "multiSelect",
  "singleSelect",
}

export type PaginatedTableFieldFilterOption = { id: string; caption: string };

export type PaginatedTableFieldFilter = {
  id: string;
  label: string;
  type: PaginatedTableFieldFilterTypes;
  defaultValue: string | string[] | null;
  initialValue?: string | string[] | null;
  options?: PaginatedTableFieldFilterOption[];
  disabled?: boolean;
};

export type PaginatedTableOrderByField = Record<string, OrderByArg>[] | null;

export type PaginatedTableFilters = {
  search?: string;
  orderBy?: PaginatedTableOrderByField;
  field?: PaginatedTableFieldFilter[];
};

export type PaginatedTablePaginationProps = {
  offset?: number | null;
  limit?: number | null;
};
